export var TABS_BUTTON_BACKDROP_SIZE = {
  xs: 16,
  sm: 24,
  md: 28,
  lg: 32,
  xl: 40
};
export var TABS_BUTTON_HORIZONTAL_PADDING = {
  xs: 16,
  sm: 18,
  md: 20,
  xl: 24
};
export var TABS_BUTTON_TOP_PADDING = {
  xs: 16,
  sm: 20,
  md: 24,
  lg: 32
};
export var TABS_BUTTON_BOTTOM_PADDING = {
  xs: 16,
  sm: 20,
  xl: 24
};
export var TABS_CONTAINER_HEIGHT = {
  xs: 48,
  sm: 56,
  md: 60,
  lg: 72,
  xl: 80
};